import type { Campaign } from '../types/whatsapp';

const NOTHING_TO_SHOW = '—';

export function campaignTitle(campaign: Campaign): string {
  return campaign.campaign_name || campaign.template_name || NOTHING_TO_SHOW;
}
